<template>
  <div class="side-btn" v-if="isAllowedPage">
    <router-link :to="{ name: ROUTE_NAME.Reservation }" class="btn-reservation">
      <img src="@assets/img/contents/icon_quick_calendar.svg" alt="" />
      <h2>RESERVATION</h2>
    </router-link>
  </div>
</template>
<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { RouteLocationNormalized, useRouter } from 'vue-router';
import { ROUTE_NAME } from '@constants';
import { useCommonStore, useUserStore } from '@stores';
import * as ChannelService from '@channel.io/channel-web-sdk-loader';

const isAllowedPage = ref(false);
const { currentRoute } = useRouter();
const commonStore = useCommonStore();
const userStore = useUserStore();
let scriptLoaded = false;

const exceptRouteList: ROUTE_NAME[] = [
  ROUTE_NAME.Reservation,
  ROUTE_NAME.ReservationStatus,
  ROUTE_NAME.Signin,
  ROUTE_NAME.Signup,
  ROUTE_NAME.FindId,
  ROUTE_NAME.FindPassword,
  ROUTE_NAME.NewPasswordAccount,
  ROUTE_NAME.UserInfoModify,
  ROUTE_NAME.NoticeWrite,
  ROUTE_NAME.NoticeModify,
  ROUTE_NAME.BannerWrite,
  ROUTE_NAME.BannerModify,
];

const createBootOptions = (isSignIn: boolean) => {
  const bootOptions = {
    pluginKey: import.meta.env.VITE_APP_CHANNEL_TALK_PLUGIN_KEY,
  };
  if (isSignIn) {
    Object.assign(bootOptions, {
      memberId: userStore.userId,
      profile: {
        name: userStore.username,
        mobileNumber: userStore.hpNo,
      },
    });
  }
  return bootOptions;
};

const initializeChannelService = (isSignIn: boolean) => {
  if (!scriptLoaded) {
    ChannelService.loadScript();
    scriptLoaded = true;
  }
  const bootOptions = createBootOptions(isSignIn);
  ChannelService.boot(bootOptions);
};

onMounted(() => {
  initializeChannelService(commonStore.isSignIn);
});

watch(currentRoute, (to: RouteLocationNormalized) => {
  const isExceptRoute = exceptRouteList.includes(to.name as ROUTE_NAME);
  isAllowedPage.value = !isExceptRoute;
});

watch(
  () => commonStore.isSignIn,
  (isSignIn) => {
    initializeChannelService(isSignIn);
  },
  {
    immediate: true,
  }
);
</script>

<style scoped lang="scss">
/* 퀵메뉴 */
.side-btn {
  position: fixed;
  right: 24px;
  bottom: 90px;
  z-index: 100;
  background: transparent;
}

.btn-reservation {
  width: 56px;
  height: 56px;
  background: var(--main-color);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  img {
    width: 36px;
    height: 36px;
  }
}

.btn-reservation h2 {
  color: #a7e9e8;
  font-weight: 700;
  display: none;
  flex-direction: column;
  font-size: 14px;
  position: absolute;
  left: -100px;
  top: 50%;
  transform: translateY(-50%);
  animation: hover 0.2s ease-in-out;
}

.btn-reservation:hover h2 {
  display: flex;
}

@keyframes hover {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*모바일*/
@media (min-width: 320px) and (max-width: 1279px) {
  .side-btn {
    display: none;
  }

  .btn-reservation h2 {
    display: none;
  }
}
</style>
